
	import { defineComponent, onMounted, reactive, ref, computed } from 'vue'
	import { getDashboardList, resetDashboard, editDashboard } from '../request'
	import { message, Modal } from 'ant-design-vue'
	import { dashboardColumns } from '../config'

	export default defineComponent({
		props: {
			value: {
				type: Object,
				default: () => ({})
			},
			sassId: {
				type: [Number, String],
				default: ''
			}
		},
		emits: ['close', 'success'],
		setup(props, { emit }) {
			const visible = ref(true)
			const dataSource = ref([])
			const currentPage = ref({
				url: '',
				code: ''
			})
			const editVisible = ref(false)

			const close = (bool: boolean) => {
				if (!bool) {
					emit('close')
				}
			}

			const getPages = async () => {
				let { data } = await getDashboardList({ bizId: props.value.id, isPackageOnly: 1 })
				dataSource.value = data
			}

			const resetPage = (code: string) => {
				Modal.confirm({
					title: '确认提示',
					content: '确认复原该页面吗？',
					okText: '确认',
					cancelText: '取消',
					onOk: async () => {
						try {
							await resetDashboard({ bizId: props.value.id, code: code })
							message.success('复原成功')
							getPages()
						} catch (error) {}
					}
				})
			}

			const editPage = (record: any) => {
				currentPage.value = record
				editVisible.value = true
			}

			const handleOk = async () => {
				if (!currentPage.value.url) {
					message.warning('报表链接不能为空！')
					return
				}
				await editDashboard({ bizId: props.value.id, code: currentPage.value.code, url: currentPage.value.url })
				editVisible.value = false
				message.success('修改成功')
				getPages()
			}

			onMounted(() => {
				getPages()
			})
			return {
				visible,
				close,
				dashboardColumns,
				dataSource,
				resetPage,
				editPage,
				currentPage,
				editVisible,
				handleOk
			}
		}
	})
